import { render, staticRenderFns } from "./client-detail.vue?vue&type=template&id=0dff8f2d"
import script from "./client-detail.vue?vue&type=script&lang=js"
export * from "./client-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports